// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalSwimmy_root__Qd_cq"};